import i18n from '@/plugins/vuei18n'

export default [
    {
        discount: false,
        label: i18n.t('steps.offer.discountTypes.none'),
        calculation: () => 0
    },
    {
        discount: true,
        label: i18n.t('steps.offer.discountTypes.percentage'),
        calculation: (value, discount) => discount * value / 100
    },
    // {
    //     discount: true,
    //     label: i18n.t('steps.offer.discountTypes.rebate'),
    //     calculation: (value, discount) => discount
    // }
]
